import { render, staticRenderFns } from "./VBaseSelect.vue?vue&type=template&id=acb0000e&scoped=true&functional=true&"
import script from "./VBaseSelect.vue?vue&type=script&lang=ts&"
export * from "./VBaseSelect.vue?vue&type=script&lang=ts&"
import style0 from "./VBaseSelect.vue?vue&type=style&index=0&id=acb0000e&lang=scss&scoped=true&"
import style1 from "./VBaseSelect.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "acb0000e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
